export default __webpack_public_path__ + "static/media/metamask.5a7dd0e5.png";